export const CONFIRM_STORAGE_ITEM = 'confirm';
